import React from 'react'
import styled from 'styled-components'
import TypistCycle from './TypistCycle'
import Hero from '../../images/gorgaslibrary01_1920.jpg'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link } from '@reach/router';
// @import url('https://fonts.googleapis.com/css2? family= Roboto:wght@300 & display=swap');

export default () => (
  <div>
    <Content>
      <TextBackground>
        <TypistCycle 
          content={['Good Data', 'Good Decisions']}
          numberOfCycles={-1}
          segmentDelay={2}
          cursor={{
            element: '_',
            hideWhenDoneDelay: 3000,
          }} 
        />
      </TextBackground>
    </Content>

    {/* Icon Menu - Adjusted for Mobile */}
    <div id="icon-menu" className="container-lg top-border">
      <div className="row px-0 py-0 justify-content-md-center">
        {[
          { to: "https://oira.ua.edu/reports/commonDataSet/", icon: "bi-bar-chart-line-fill", label: "Common Data Set" },
          { to: "https://oira.ua.edu/new/interactiveFB/", icon: "bi-book-half", label: "Factbook" },
          { to: "/new/requests/", icon: "bi-inboxes-fill", label: "Information Requests" },
          { to: "/new/internalReports/", icon: "bi-file-earmark-bar-graph", label: "Internal Reports<span class='d-none d-md-inline'><br /></span> (Login Required)" },
          { to: "/new/soi/", icon: "bi-chat-right-text-fill", label: "Student Opinions of Instruction" },
        ].map((item, idx) => {
          const isExternal = item.to.startsWith('http');
          const Wrapper = isExternal ? 'a' : Link;
          const wrapperProps = isExternal
            ? { href: item.to, target: '_self', rel: 'noopener noreferrer' }
            : { to: item.to };

          return (
            <Wrapper
              key={idx}
              {...wrapperProps}
              className="side-border col-12 col-md-2 mb-0 text-left text-md-center"
            >
              <button type="button" className="icon-menu-btn border border-0 w-100 text-left text-md-center">
                <div className="icon-menu">
                  <span className="icon-menu-icon d-none d-md-inline">
                    <i className={`bi ${item.icon}`}></i>
                  </span>
                  <br />
                  <span
                    className="icon-menu-text"
                    dangerouslySetInnerHTML={{ __html: item.label }}
                  ></span>
                </div>
              </button>
            </Wrapper>
          );
        })}
      </div>
    </div>
  </div>
);

const Content = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-flow: column;
  height: 500px;
  -webkit-overflow-scrolling: touch;
  align-items: center;
  align-content: center;
  justify-content: center;
  background: url(${Hero}) no-repeat;
  background-size: cover;
  background-position: center center;

  h1 {
    font-size: 3vw;
  }
  @media (max-width: 768px) {
    height: 300px;
  }
`

const TextBackground = styled.div`
  margin-top: -5em;
  color: RGBA(0, 0, 0, 0.8);
  border-radius: 5px;
  font-weight: 700;
  padding-left: 5px;
  padding-right: 10px;
  line-height: 1.5em;
  font-size: 3.5em;
  text-align: center;
  background: RGBA(245, 243, 247, 0.6);
  .Typist .Cursor {
    display: inline-block;
  }
  .Typist .Cursor--blinking {
    opacity: 1;
    animation: blink 1s linear infinite;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    line-height: 3.5rem;
    font-size: 2.5rem;
    margin-top: -3.5em;
  }
`
